import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BaseUrl = process.env.REACT_APP_BASH_URL;

// Fetch vendor list by category
export const getVendorListByCategory = createAsyncThunk(
  'vendorAccess/getVendorListByCategory',
  async (category, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("admin-auth-token");
      const options = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
      const response = await axios.get(`${BaseUrl}/admin/members/list`, { headers: options });
      return response.data.result;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getAllCategories = createAsyncThunk(
  'vendorAccess/getAllCategories',
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("admin-auth-token");
      const options = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
      const response = await axios.get(`${BaseUrl}/admin/product/categories`, { headers: options });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
// Fetch vendor menu access
export const getVendorMenuAccess = createAsyncThunk(
  'vendorAccess/getVendorMenuAccess',
  async ({ category, subCategory }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("admin-auth-token");
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
      const url = `${BaseUrl}/admin/product/category/access?category=${encodeURIComponent(category)}&subCategory=${encodeURIComponent(subCategory || "")}`;
      const { data } = await axios.get(url, { headers });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// Update vendor menu access
export const updateVendorMenuAccess = createAsyncThunk(
  'vendorAccess/updateVendorMenuAccess',
  async ({ category, subCategory, vendorIds }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("admin-auth-token");
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
      const payload = {
        category: encodeURIComponent(category),
        subCategory: encodeURIComponent(subCategory || ""),
        vendorIds,
      };
      const { data } = await axios.post(`${BaseUrl}/admin/product/category/update-access`, payload, { headers });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);


// Slice
const vendorAccessSlice = createSlice({
  name: 'vendorAccess',
  initialState: {
    vendorList: [],
    accessList: [],
    categories: [],
    loading: false,
    error: null,
    updateSuccess: false,
  },
  reducers: {
    clearVendorAccessError: (state) => {
      state.error = null;
    },
    resetAccessUpdateState: (state) => {
      state.updateSuccess = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getVendorListByCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getVendorListByCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.vendorList = action.payload;
      })
      .addCase(getVendorListByCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getVendorMenuAccess.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getVendorMenuAccess.fulfilled, (state, action) => {
        state.loading = false;
        state.accessList = action.payload;
      })
      .addCase(getVendorMenuAccess.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getAllCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = action.payload;
      })
      .addCase(getAllCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateVendorMenuAccess.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.updateSuccess = false;
      })
      .addCase(updateVendorMenuAccess.fulfilled, (state, action) => {
        state.loading = false;
        state.updateSuccess = true;
      })
      .addCase(updateVendorMenuAccess.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.updateSuccess = false;
      });
  },
});

export const { clearVendorAccessError, resetAccessUpdateState } = vendorAccessSlice.actions;
export default vendorAccessSlice.reducer;
